import FETCH from "../utils/fetch";
import ROUTES from "../config/routes";

const financialAdvisorClientListing = async (page, query) => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_AVISOR_CLIENT_LISTING}`,
    id: query.trim() === "" ? `?page=${page}&limit=10` : `?page=${page}&limit=10&name=${query}` ,
  });
  return res;
};

const deletefinancialAdvisorClient = async (id) => {
  let res = await FETCH.deletee({
    url: ROUTES.DELETE_ADVISOR_CLIENT,
    id,
  });
  return res;
};

const FINANCIAL_ADVISOR_API = {
  financialAdvisorClientListing,
  deletefinancialAdvisorClient,
};

export default FINANCIAL_ADVISOR_API;
